export default function TOS() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <h1 className="font-display text-4xl font-bold mb-2">Terms of Service</h1>
      <p className="text-muted text-sm mb-10">Last updated: {new Date().toLocaleDateString()}</p>

      <div className="prose prose-invert max-w-none space-y-8 text-sm leading-relaxed text-muted">
        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">1. Acceptance of Terms</h2>
          <p>
            By purchasing and using Exusiai ("the Software"), you agree to be bound by these Terms of
            Service. If you do not agree, do not purchase or use the Software.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">2. License Grant</h2>
          <p>
            Upon successful payment, you are granted a non-exclusive, non-transferable, revocable
            license to use the Software on a single device. The license is bound to your hardware
            (HWID) and may not be shared, resold, or distributed.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">3. HWID Binding</h2>
          <p>
            Your license is activated on first use and bound to your device hardware. You may reset
            this binding up to 2 times per calendar month. Abuse of the reset system may result in
            license suspension.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">4. Refund Policy</h2>
          <p>
            All sales are final. No refunds are offered under any circumstances. Due to the digital
            nature of the product, we cannot revoke access after delivery.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">5. Chargebacks</h2>
          <p>
            Initiating a chargeback or payment dispute will result in immediate and permanent
            suspension of your license. If you have an issue, you must contact us before disputing a
            charge.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">6. Acceptable Use</h2>
          <p>
            The Software is designed for use on servers and in environments that tolerate such
            modifications, or in single-player mode. You are solely responsible for any consequences
            of using the Software, including bans or account suspensions imposed by third-party
            servers or services.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">7. No Warranty</h2>
          <p>
            The Software is provided "as is" without warranty of any kind. We do not guarantee that
            the Software will function uninterrupted or error-free, or that it will remain
            undetectable by anti-cheat systems.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">8. Limitation of Liability</h2>
          <p>
            We shall not be liable for any damages arising from the use or inability to use the
            Software, including but not limited to account bans, data loss, or hardware issues.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">9. Termination</h2>
          <p>
            We reserve the right to terminate or suspend your license at any time if you violate
            these Terms.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">10. Changes</h2>
          <p>
            We may update these Terms at any time. Continued use of the Software after changes
            constitutes acceptance of the new Terms.
          </p>
        </section>
      </div>
    </div>
  );
}
